<template>
   <div>
    <module-card title="">
      <el-form inline :model="searchForm">
        <el-form-item label="创建日期">
          <date-range-picker
            :value="createTime"
            @change="value => createTime = value"
            ref="createTime"
            @getChange="createTimeChange"
            :maxRange="60"
          ></date-range-picker>
        </el-form-item>
        <el-form-item label="模板名称">
          <el-input v-model="searchForm.templateName"></el-input>
        </el-form-item>
        <el-form-item label="活动名称">
          <select-page
              class="branch-input"
              :value="searchForm.activityId"
              :request-data="activitySelectReq"
              placeholder="全部"
              option-value="code"
              option-name="name"
              valueName="name"
              @getSelect="getActivityName"
              label="活动名称"
              requestUrl="getTemplateActivityList"></select-page>
          <!-- <el-select v-model="searchForm.activityId">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item,index) in activityList" :label="item.name" :value="item.code" :key="index"></el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.status" clearable>
            <el-option label="废弃" :value="0"></el-option>
            <el-option label="启用" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item >
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="searchBtnClick"
            :loading="searchLoading"
          >查询</el-button>
          <el-button type="primary" icon="el-icon-plus"  @click="addNewTemplate">新增模板</el-button>
        </el-form-item>
      </el-form>
      <el-table border :data="tableData" v-loading="searchLoading">
        <el-table-column v-for="(item,index) in columns" :formatter="item.formatter" :prop="item.key" :label="item.label" :key="index"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <div>
              <auth-button v-if="scope.row.status === 1" auth-type="span" opt="detail_export" label="导出" @click.native="exportDetails(scope.row)"></auth-button>
              <auth-button auth-type="span" opt="detail_check" label="查看" @click.native="checkDetails(scope.row)"></auth-button>
              <auth-button v-if="scope.row.status === 1" auth-type="span" opt="detail_edit" label="修改" @click.native="editDetails(scope.row)"></auth-button>
              <auth-button v-if="scope.row.status === 1" auth-type="span" opt="detail_abandon" label="废弃" @click.native="abandonDetails(scope.row)"></auth-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </module-card>
    <el-col>
      <Pagination @changePage="onChangeCardCurrentPage" :count="total" :page-no="pageNo" :size="pageSize"></Pagination>
    </el-col>
    <dialog-info :title="dialogTitle" :visible.sync="showDialog" :showCancelBtn="false" :footerAlign="'center'" size="large" :confirmText="confirmText" @confirm="confirmClick">
      <el-form :model="templateForm" :rules="dialogFormRules" ref="templateForm" :disabled="dialogTitle==='模板详情'" label-width="100px">
        <el-form-item label="模板名称：" prop="templateName">
          <el-input v-model="templateForm.templateName" placeholder="请输入模板名称" style="width:50%"></el-input>
        </el-form-item>
        <el-form-item label="活动名称：" prop="activityId">
          <select-page
              style="width:50%"
              class="branch-input"
              :value="templateForm.activityId"
              :request-data="activitySelectReq"
              placeholder="请选择活动名称"
              option-value="code"
              option-name="name"
              valueName="name"
              @getSelect="getDialogActivityName"
              label="活动名称"
              requestUrl="getTemplateActivityList"></select-page>
        </el-form-item>
        <el-form-item label="选择导出表头：" label-width="120px">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
          <el-checkbox-group v-model="checkedList" @change="handleCheckedItemChange">
            <el-checkbox v-for="(item,index) in exportHeaderList" :label="item.fieldName" :key="index">{{item.fieldHeaderName}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
    </dialog-info>
    <dialog-info title="导出" :visible.sync="showExportDialog" :showCancelBtn="false" :confirmLoading="exportLoading" :footerAlign="'center'" size="middle" confirmText="导出" @confirm="confirmExport">
      <el-form inline label-width="120px">
        <el-form-item label="系统绑卡日期：">
          <date-range-picker
            :value="cardBindTime"
            @change="value => cardBindTime = value"
            ref="createTime"
            @getChange="cardBindTimeChange"
            :maxRange="365"
          ></date-range-picker>
        </el-form-item>
      </el-form>
    </dialog-info>
    <dialog-info title="废弃模板" :visible.sync="showAbandonDialog" :footerAlign="'center'" confirmText="确定" @confirm="confirmAbandon">
      <span>确认废弃该模板吗</span>
    </dialog-info>
  </div>
</template>

<script>
import dialogInfo from '@/components/layout/dialogInfo'
import dateRangePicker from '@/components/dateRangePicker'
import Pagination from '@/components/pagination'
import selectPage from '@/components/selectPage'
import { downJumpConfirm } from '@/assets/js/utils'
export default {
  name: 'exportTemplateDetail',
  components: { dateRangePicker, dialogInfo, Pagination, selectPage },

  data () {
    return {
      createTime: [],
      searchLoading: false,
      searchForm: {
        templateName: '',
        activityId: '',
        status: ''
      },
      activitySelectReq: { tempalteId: '' },
      columns: [
        { label: '创建时间', key: 'createTime' },
        { label: '模板名称', key: 'templateName' },
        { label: '活动名称', key: 'activityName' },
        { label: '状态', key: 'status', formatter: (row) => row.status === 1 ? '启用' : '废弃' },
        { label: '创建人', key: 'creator' }
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNo: 1,
      dialogTitle: '查看详情',
      showDialog: false,
      confirmText: '',
      templateForm: {
        templateName: '',
        templateId: '',
        activityName: '',
        activityId: ''
      },
      dialogFormRules: {
        templateName: [
          { required: true, message: '请输入模板名称', trigger: 'blur' }
        ],
        activityId: [
          { required: true, message: '请选择活动名称', trigger: 'change' }
        ]
      },
      checkAll: false,
      isIndeterminate: true,
      activityList: [],
      exportHeaderList: [],
      checkedList: [],
      showExportDialog: false,
      showAbandonDialog: false,
      cardBindTime: [],
      templateId: '',
      exportLoading: false,
      abandonParams: {}
    }
  },

  computed: {},

  created () {
    this.getExportHead()
    this.searchBtnClick()
  },

  mounted () {},

  methods: {
    getActivityList () { // 获取活动列表
      this.$axios.post(this.$api.getTemplateActivityList).then(res => {
        if (res.respCode === '0') {
          this.activityList = res.data
        }
      })
    },
    getActivityName (result) {
      if (result) {
        this.searchForm.activityId = result.value
      } else {
        this.searchForm.activityId = ''
      }
    },
    getDialogActivityName (result) {
      console.log(result)
      if (result) {
        this.templateForm.activityId = result.value
      } else {
        this.templateForm.activityId = ''
      }
    },
    getExportHead () {
      const params = { templateType: this.$route.query.type }
      this.$axios.post(this.$api.getCustomExportHeader, params).then(res => {
        if (res.respCode === '0') {
          this.exportHeaderList = res.data
        }
      })
    },
    createTimeChange (val) {
      this.createTime = val
    },
    searchBtnClick () {
      this.pageNo = 1
      this.getList()
    },
    getList () {
      const params = {
        ...this.searchForm,
        templateType: this.$route.query.type,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        createTimeStart: this.createTime && this.createTime.length ? this.createTime[0] : '',
        createTimeEnd: this.createTime && this.createTime.length ? this.createTime[1] : ''
      }
      this.searchLoading = true
      this.$axios.post(this.$api.getTemplateList, params).then(res => {
        this.searchLoading = false
        if (res.respCode === '0') {
          this.tableData = res.data.list
          this.total = res.data.count
        } else {
          this.tableData = []
          this.total = 0
        }
      })
    },
    onChangeCardCurrentPage (val) {
      this.pageNo = val
      this.getList()
    },
    resetFields () {
      this.clearValidate()
      this.templateForm.templateName = ''
      this.templateForm.activityId = ''
    },
    clearValidate () {
      this.$nextTick(() => {
        this.$refs.templateForm.clearValidate()
      })
    },
    addNewTemplate () {
      this.dialogTitle = '新增导出模板'
      this.confirmText = '新增'
      this.showDialog = true
      this.checkedList = []
      this.resetFields()
      this.handleCheckedItemChange()
    },
    checkDetails (row) {
      this.dialogTitle = '模板详情'
      this.confirmText = '关闭'
      this.showDialog = true
      this.clearValidate()
      this.templateForm = JSON.parse(JSON.stringify(row))
      this.checkedList = row.headerList
      this.handleCheckedItemChange()
    },
    exportDetails (row) {
      this.cardBindTime = []
      this.showExportDialog = true
      this.templateId = row.templateId
    },
    editDetails (row) {
      this.dialogTitle = '修改模板详情'
      this.confirmText = '确认修改'
      this.showDialog = true
      this.clearValidate()
      this.templateForm = JSON.parse(JSON.stringify(row))
      this.checkedList = row.headerList
      this.handleCheckedItemChange()
    },
    abandonDetails ({ templateId, templateName, activityId }) {
      this.showAbandonDialog = true
      this.abandonParams = { templateId, templateName, activityId, status: 0 }
    },
    editTemplate () {
      const params = {
        ...this.templateForm,
        templateHeader: this.checkedList
      }
      this.$axios.post(this.$api.editTemplate, params).then(res => {
        if (res.respCode === '0') {
          this.$message({
            type: 'success',
            message: '修改成功'
          })
          this.showDialog = false
          this.getList() // 刷新列表
        }
      })
    },
    addTemplate () {
      const params = {
        ...this.templateForm,
        templateHeader: this.checkedList,
        templateType: this.$route.query.type
      }
      this.$axios.post(this.$api.addTemplate, params).then(res => {
        if (res.respCode === '0') {
          this.$message({
            type: 'success',
            message: '新增成功'
          })
          this.showDialog = false
          this.getList()
        }
      })
    },
    handleCheckAllChange (val) {
      this.checkedList = val ? this.exportHeaderList.map(item => item.fieldName) : []
      this.isIndeterminate = false
    },
    handleCheckedItemChange () {
      const checkedCount = this.checkedList.length
      this.checkAll = checkedCount === this.exportHeaderList.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.exportHeaderList.length
    },
    confirmClick () {
      if (this.dialogTitle === '模板详情') {
        this.showDialog = false
      } else {
        this.$refs.templateForm.validate(valid => {
          if (valid) {
            if (!this.checkedList.length) {
              return this.$message({
                type: 'warning',
                message: '请选择导出表头'
              })
            }
            if (this.confirmText === '确认修改') {
              this.editTemplate()
            } else {
              this.addTemplate()
            }
          }
        })
      }
    },
    cardBindTimeChange (val) {
      this.cardBindTime = val
    },
    confirmExport () {
      if (!this.cardBindTime.length) {
        return this.$message({
          type: 'warning',
          message: '请选择系统绑卡日期'
        })
      }
      const params = {
        templateId: this.templateId,
        exportReq: {
          bindCardTimeStart: this.cardBindTime && this.cardBindTime.length ? this.cardBindTime[0] : '',
          bindCardTimeEnd: this.cardBindTime && this.cardBindTime.length ? this.cardBindTime[1] : ''
        }
      }
      this.exportLoading = true
      this.$axios.post(this.$api.exportTemplate, params).then(res => {
        this.exportLoading = false
        if (res.respCode === '0') {
          downJumpConfirm.call(this)
          this.showExportDialog = false
        }
      })
    },
    confirmAbandon () {
      this.$axios.post(this.$api.abandonTemplate, this.abandonParams).then(res => {
        if (res.respCode === '0') {
          this.showAbandonDialog = false
          this.getList()
        }
      })
    }
  }
}
</script>
<style lang="css" scoped></style>
